import { Box, Dialog, IconButton, useMediaQuery, useTheme } from '@mui/material'
import React from 'react'
import Login from './Login'
import SignUp from './SignUp'
import ForgotPassword from './ForgotPassword'
import AuthDialogLeftView from './AuthDialogLeftView'
import { Close } from '@mui/icons-material'

interface AuthDialogProps {
  authStep: string
  open: boolean
  onClose: () => void
}

const AuthDialog = ({ authStep, open, onClose }: AuthDialogProps) => {
  const theme = useTheme()
  const lessThanMedium = useMediaQuery(theme.breakpoints.down('md'))

  return (
    <Dialog
      open={open}
      onClose={onClose}
      maxWidth='xl'
      fullWidth
      PaperProps={{
        sx: {
          borderRadius: '20px',
          maxWidth: '1200px',
          maxHeight: '90vh',
          backgroundColor: '#fafafa',
          overflow: 'hidden',
          boxShadow: '0 20px 60px rgba(0, 0, 0, 0.3)',
        },
      }}
    >
      <Box
        sx={{
          display: 'flex',
          width: '100%',
          height: '100%',
          minHeight: '600px',
          position: 'relative',
        }}
      >
        {/* Close Button */}
        <IconButton
          onClick={onClose}
          sx={{
            position: 'absolute',
            right: 20,
            top: 20,
            zIndex: 10,
            width: '44px',
            height: '44px',
            backgroundColor: 'rgba(255, 255, 255, 0.9)',
            backdropFilter: 'blur(10px)',
            transition: 'all 0.2s cubic-bezier(0.4, 0, 0.2, 1)',
            '&:hover': {
              backgroundColor: 'rgba(239, 68, 68, 0.1)',
              transform: 'rotate(90deg)',
            },
            '&:active': {
              transform: 'rotate(90deg) scale(0.95)',
            },
          }}
        >
          <Close />
        </IconButton>

        {/* Left Side - Hero/Info */}
        {!lessThanMedium && (
          <Box
            sx={{
              flex: 1,
              display: 'flex',
              backgroundColor: '#ffffff',
              borderRight: '1px solid #e0e0e0',
            }}
          >
            <AuthDialogLeftView />
          </Box>
        )}

        {/* Right Side - Forms */}
        <Box
          sx={{
            flex: 1,
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            backgroundColor: '#ffffff',
            overflowY: 'auto',
          }}
        >
          {authStep === 'login' ? (
            <Login />
          ) : authStep === 'signup' ? (
            <SignUp />
          ) : (
            authStep === 'forgot-password' && <ForgotPassword />
          )}
        </Box>
      </Box>
    </Dialog>
  )
}

export default AuthDialog
